<al-budget-group-base [node]="node"
                      [translationKey]="translationKey"
                      [icon]="faUsers"
                      [refreshSubject]="refreshSubject" />

<al-cell-drop-zone [node]="node"
                   [droppable]="isDroppable"
                   (dragOverDelay)="expand()" />